export default __webpack_public_path__ + "static/media/Minicard_4c.cc890d74.svg";